// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuSection-sideMenuGroupCaption-JhRvw {
    margin-top: 20px;
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: var(--sideMenu-secondary-foreground);
    text-align: start;
    padding-left: 16px;
    padding-right: 16px;
}

.SideMenuSection-sideMenuGroupCaptionText-gKzbi {
    position: relative;
    display: inline-block;
    max-width: 100%;
    white-space: pre-line;
    word-break: break-word;
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/SideBar/SideMenuSection.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2CAA2C;IAC3C,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,0BAA0B;AAC9B","sourcesContent":[".sideMenuGroupCaption {\n    margin-top: 20px;\n    margin-bottom: 8px;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 500;\n    color: var(--sideMenu-secondary-foreground);\n    text-align: start;\n    padding-left: 16px;\n    padding-right: 16px;\n}\n\n.sideMenuGroupCaptionText {\n    position: relative;\n    display: inline-block;\n    max-width: 100%;\n    white-space: pre-line;\n    word-break: break-word;\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideMenuGroupCaption": `SideMenuSection-sideMenuGroupCaption-JhRvw`,
	"sideMenuGroupCaptionText": `SideMenuSection-sideMenuGroupCaptionText-gKzbi`
};
module.exports = ___CSS_LOADER_EXPORT___;
